import React from 'react';
import Modal from 'react-modal';

interface IProps {
  showGeneralNotificationsModal: boolean;
  onClose: () => void;
  onCancel: () => void;
  onYesClick: (header: string, body: string) => void;
}

class GeneralNotificationsModal extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      header: '',
      body: '',
    };
  }

  public render() {
    return (
      <div>
        <Modal
          isOpen={this.props.showGeneralNotificationsModal}
          className='modal-content'
          overlayClassName='modal-overlay'
          ariaHideApp={false}
          contentLabel='Columns'
        >
          <React.Fragment>
            <div className='column-label content-margin'>
              <h2 className='column-header'>
                Send an App Notification
              </h2>
              <button
                className='modal-close-button'
                onClick={this.props.onClose}
              >
                X
              </button>
            </div>

            <div style={{ padding: '20px' }}>
              <div style={{ marginBottom: '15px' }}>
                <label>Header</label>
                <input
                  type='text'
                  value={this.state.header}
                  onChange={this.handleHeaderChange}
                  style={{ width: '100%', padding: '8px' }}
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label>Body</label>
                <textarea
                  value={this.state.body}
                  onChange={this.handleBodyChange}
                  style={{ width: '100%', padding: '8px', minHeight: '100px' }}
                />
              </div>
            </div>

            <div style={{ textAlign: 'right' }}>
              <button onClick={this.props.onCancel}>Cancel</button>
              <button onClick={this.handleSubmit} style={{ marginLeft: '10px' }}>
                Send
              </button>
            </div>
          </React.Fragment>
        </Modal>
      </div>
    );
  }

  private handleHeaderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ header: e.target.value });
  };

  private handleBodyChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ body: e.target.value });
  };

  private handleSubmit = () => {
    this.props.onYesClick(this.state.header, this.state.body);

    this.setState({
      header: '',
      body: '',
    });
  };
}

export default GeneralNotificationsModal;
